import { createStore } from 'vuex'
import { authentication } from './authentication.module';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    authentication
  }
})
